import React, { useEffect, useState } from "react";

import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { IgTextField } from "@intelligems/ig-theme/IgTextField";
import Stack from "@mui/material/Stack";

interface URLInputDialogProps {
  open?: boolean;
  onApply?: (url: string) => void;
  onClose?: () => void;
}

export const URLInputDialog = ({
  open = false,
  onClose,
  onApply,
}: URLInputDialogProps) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (open) {
      setUrl("");
    }
  }, [open]);

  return (
    <IgDialog
      title="Add image URL"
      showDialog={open}
      handleClose={onClose}
      showCloseIcon
      maxWidth="sm"
      dialogHeight={null}
      dontUseDialogContent
      yesButtonText="Apply"
      noButtonText="Cancel"
      handleYesClick={() => onApply?.(url)}
      handleNoClick={onClose}
      yesButtonDisabled={!url}
      rawContent={
        <Stack spacing={2}>
          <IgTextField
            fullWidth
            size="small"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Paste image URL"
            label="Image URL"
          />
        </Stack>
      }
    />
  );
};
